import { Icon } from "./Icon.tsx";

/** AddConduitIcon.tsx's two-nodes-joined-by-a-pipe glyph, with a downward
 * chevron at the midpoint (discharge) marking it an outlet rather than a
 * plain conduit. */
export function AddOutletIcon() {
  return (
    <Icon>
      <circle cx="5" cy="19" r="2.5" />
      <circle cx="19" cy="5" r="2.5" />
      <path d="M7 17.5L17 6.5" />
      <path d="M9.5 11.5l2 2 2-2" />
    </Icon>
  );
}
